import React, { ForwardRefRenderFunction } from "react";
import BrandingIcon from "../icons/BrandingIcon";
import colors from "../../style/colors";
import FeedbackType from "../../FeedbackType";

export type InlineCardProps = {
  title: string;
  type: FeedbackType;
  top: number;
  left: number;
  onHoverStarted?: () => void;
  onHoverEnded?: () => void;
  children?: React.ReactNode;
};

// TODO(feature): onDismiss button

const InlineCard: ForwardRefRenderFunction<HTMLDivElement, InlineCardProps> = (
  {
    title,
    type,
    top,
    left,
    onHoverStarted,
    onHoverEnded,
    children,
  }: InlineCardProps,
  ref: React.Ref<HTMLDivElement>
) => {
  const textColor = colors.actionable[type].text;
  return (
    <div
      ref={ref}
      className="absolute z-10 shadow-xl rounded w-72 overflow-hidden bg-white select-none flex flex-col pb-2"
      style={{
        top,
        left,
      }}
      onMouseOver={() => onHoverStarted?.()}
      onMouseLeave={() => onHoverEnded?.()}
      onFocus={() => onHoverStarted?.()}
      onBlur={() => onHoverEnded?.()}
    >
      <span className={`text-xxs ${textColor} pl-3.5 pt-2 pb-1`}>{title}</span>
      {children}
      <div className="flex justify-end pr-2">
        <BrandingIcon />
      </div>
    </div>
  );
};

export default React.forwardRef(InlineCard);
